/*
 * Author: Roger
 * File Created: Wednesday, 24-08-07 11:08 am
 * Last Modified: Wednesday, 24-08-14 03:08 pm, by Roger
 */
'use client';

import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';
import Facebook from './Facebook';
import LinkedIn from './LinkedIn';
import Telegram from './Telegram';
import Twitter from './Twitter';
import YouTube from './YouTube';
const Icons = {
  Facebook,
  LinkedIn,
  Telegram,
  Twitter,
  YouTube
};
export type IconName = keyof typeof Icons;
interface FooterIconProps extends SvgIconProps {
  name: IconName;
}
const FooterIcon: React.FC<FooterIconProps> = ({
  name,
  ...svgProps
}) => {
  const Svg = Icons[name as IconName];
  return <SvgIcon inheritViewBox {...svgProps} data-sentry-element="SvgIcon" data-sentry-component="FooterIcon" data-sentry-source-file="index.tsx">
      <Svg data-sentry-element="Svg" data-sentry-source-file="index.tsx" />
    </SvgIcon>;
};
export default FooterIcon;